import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michał Kleszczyński
 * id 6E502BA0-5D71-4607-BA94-CDEF31BBF07C
 * name table-split-cell
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-split-cell.svg
 * tags
 * - Text / Content / Format 
 */
export const TableSplitCellIcon = createSvgIcon(<><path d="M19 14H21V20H3V14H5V18H19V14M3 4V10H5V6H19V10H21V4H3M11 11V13H8V15L5 12L8 9V11H11M16 11V9L19 12L16 15V13H13V11H16Z" /></>, 'TableSplitCellIcon');
export default TableSplitCellIcon